import loadable from '@loadable/component';

const ManageApps = loadable(() => import('./manage-apps'));

export { ManageApps };
